<div class="d-flex align-items-center justify-content-between">
    <span class="list-title field-required">{{ 'roles.registrations' | translate }} ({{selectedRegistrations.length}})</span>
    <span *ngIf="availableRegistrations?.length > 0" (click)="selectAllRegistrations()"
          class="btn btn-outline-primary align-self-end">{{'Select All' | translate}}</span>
</div>

<div class="page-table expanded-list pb-0" (click)="showList = false; $event.stopPropagation();">
    <div class="list-group list-item-container">
        <div *ngFor="let selectedRegistration of selectedRegistrations; let i=index;"
                class="list-item item">
            <div class="w-100 d-flex align-items-between">
                <span>{{selectedRegistration.text}}</span>
                <span *ngIf="selectedRegistration.hasResult" class="cursor-pointer toggle mr-5 ml-auto" (click)="selectedRegistration.finalResultIssued = !selectedRegistration.finalResultIssued; saveRegistration(selectedRegistration)">
                    <i class="ml-r toggle-label fas {{selectedRegistration.finalResultIssued ? 'fa-toggle-large-on toggle-primary' : 'fa-toggle-large-on fa-flip-horizontal toggle__icon inactive toggle-disabled'}}"></i>
                        {{ 'Issues final result' | translate }}
                    </span>
            </div>
            <div class="d-flex align-items-center">
                <confirmation [showTrashIcon]="true"
                                [question]="'confirm.areyousure'"
                                [extraClasses]="'d-flex'"
                                (click)="$event.stopPropagation()"
                                (isConfirmed)="removed(selectedRegistration)"></confirmation>
            </div>
        </div>
    </div>
    <drawer-items class="mt-1" *ngIf="availableRegistrations?.length"
            [items]="availableRegistrations"
            [title]="'roles.registrations'"
            (itemSelected)="selected($event)"
            [multiselect]="true"
            [showEditButton]="false"
            [openListButtonLabel]="'Select'"></drawer-items>
</div>
